import { useCallback, useEffect, useState } from "react";

import * as Scrivito from "scrivito";
import { useAppBaseContext } from "providers";
import { useProjectDataStore } from "stores/projectStore";

export const useNavigateToCustomProduct = () => {
  const projectId = useProjectDataStore((state) => state.projectId);
  const { isSameProj } = useAppBaseContext() as { isSameProj: boolean };

  const [customItemObj, setCustomItemObj] = useState<Scrivito.Obj | null>(null);

  useEffect(() => {
    Scrivito.load(() => {
      const basePath = isSameProj ? "same/en/" : "/website/de/";

      return Scrivito.Obj.where("_objClass", "equals", "CustomProductItem")
        .and("_path", "startsWith", basePath)
        .first();
    }).then((obj) => setCustomItemObj(obj));
  }, [isSameProj]);

  const navigateToCustomProduct = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (customdata: Record<string, any>) => {
      if (!customItemObj) {
        return;
      }
      Scrivito.navigateTo(() => customItemObj, {
        params: {
          ...customdata,
          projectId,
        },
      });
    },
    [customItemObj, projectId],
  );

  return navigateToCustomProduct;
};
